import { Instagram } from "lucide-react";
import Reveal from "./Reveal";
import { TEAM } from "../data/office";

export default function Team() {
  return (
    <section id="equipe" data-testid="team-section" className="relative bg-navy-950 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono-meta text-[11px] uppercase tracking-[0.35em] text-gold-400">
            Nossas advogadas
          </p>
          <h2 className="font-display mt-4 max-w-2xl text-4xl font-medium leading-tight text-cream sm:text-5xl lg:text-6xl">
            Quem defende <em className="gold-text">você</em>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
          {TEAM.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.1}>
              <article
                data-testid={`team-card-${i}`}
                className="group h-full overflow-hidden rounded-2xl border border-navy-600/60 bg-card transition-all duration-500 hover:-translate-y-1 hover:border-gold-500/50"
              >
                <div className="relative overflow-hidden">
                  <img
                    data-testid={`team-photo-${i}`}
                    src={p.photo}
                    alt={`Advogada ${p.name}`}
                    className="aspect-[3/4] w-full bg-navy-800 object-contain"
                    style={{ filter: "saturate(0.95)" }}
                  />
                  <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-navy-900 to-transparent" />
                </div>
                <div className="p-6">
                  <h3 className="font-display text-2xl font-semibold text-cream">{p.name}</h3>
                  <p className="font-mono-meta mt-1.5 text-[11px] uppercase tracking-[0.2em] text-gold-400">
                    {p.oab}
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-mist">{p.short}</p>
                  <p className="mt-3 border-l-2 border-gold-500/50 pl-3 text-sm italic leading-relaxed text-cream/80">
                    {p.mission}
                  </p>
                  <a
                    data-testid={`team-instagram-${i}`}
                    href={`https://instagram.com/${p.instagram.replace("@", "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-mist transition-colors hover:text-gold-400"
                  >
                    <Instagram className="h-3.5 w-3.5" />
                    {p.instagram}
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
